import SurveyTemplates from './components/SurveyTemplates';
export default SurveyTemplates;